import ChartsHomepage from '..';

export default ChartsHomepage;
